/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type CandidateReviewSummaryDecision = typeof CandidateReviewSummaryDecision[keyof typeof CandidateReviewSummaryDecision];


export const CandidateReviewSummaryDecision = {
  yes: 'yes',
  maybe: 'maybe',
  no: 'no',
} as const;
